import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useRecipientsSelectContext } from './RecipientsSelectContext'

/**
 * a complex {@link CIMSSelect} component for users, non user emails,
 * and recipient groups (if included in provider)
 *
 * wrap anything using this component in the RecipientsSelectProvider
 */
const RecipientsSelect: React.FC<CommonSelect<'virtual'>> = (props) => {
  const { options, loading } = useRecipientsSelectContext()
  return <CIMSSelect options={options} loading={loading} virtual {...props} />
}

export default RecipientsSelect
